import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//进销存报表
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}